import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

interface Entry {
  id: string;
  title: string;
  company: string;
  location: string;
  postedAt: string;
}

export default function LatestJobs() {
  const navigate = useNavigate();

  // Dummy data
  const [jobs] = useState<Entry[]>([
    { id: "1", title: "Frontend Developer", company: "ForumDE", location: "Remote", postedAt: "2025-10-27" },
    { id: "2", title: "Backend Engineer", company: "TechNova", location: "Bangalore", postedAt: "2025-10-26" },
    { id: "3", title: "Fullstack Engineer", company: "CodeWorks", location: "Pune", postedAt: "2025-10-25" },
    { id: "4", title: "Data Analyst", company: "InnoData", location: "Delhi", postedAt: "2025-10-24" },
  ]);

  const [internships] = useState<Entry[]>([
    { id: "1", title: "Marketing Intern", company: "AdSpark", location: "Mumbai", postedAt: "2025-10-23" },
    { id: "2", title: "UI/UX Intern", company: "Designify", location: "Remote", postedAt: "2025-10-22" },
    { id: "3", title: "Research Intern", company: "DeepThink", location: "Hyderabad", postedAt: "2025-10-21" },
    { id: "4", title: "Content Intern", company: "Wordly", location: "Chennai", postedAt: "2025-10-20" },
  ]);

  const maxVisible = 3;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Latest Job & Internship Openings</h1>
        <div className="flex gap-3">
          <button
            onClick={() => navigate("/jobs/create")}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            + Add Job
          </button>
          <button
            onClick={() => navigate("/internships/create")}
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
          >
            + Add Internship
          </button>
        </div>
      </div>

      {/* Jobs Table */}
      <div className="mb-10">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-xl font-semibold text-gray-800">Latest Jobs</h2>
          {jobs.length > maxVisible && (
            <button
              onClick={() => navigate("/jobs/all")}
              className="text-blue-600 hover:underline text-sm font-medium"
            >
              View More →
            </button>
          )}
        </div>
        <div className="overflow-x-auto bg-white rounded-lg shadow">
          <table className="w-full text-left">
            <thead className="bg-gray-200 text-gray-700">
              <tr>
                <th className="p-3">Title</th>
                <th className="p-3">Company</th>
                <th className="p-3">Location</th>
                <th className="p-3">Posted</th>
                <th className="p-3 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {jobs.slice(0, maxVisible).map((job) => (
                <tr key={job.id} className="border-b hover:bg-gray-50">
                  <td className="p-3">{job.title}</td>
                  <td className="p-3">{job.company}</td>
                  <td className="p-3">{job.location}</td>
                  <td className="p-3">{job.postedAt}</td>
                  <td className="p-3 text-right flex justify-end gap-2">
                    <button
                      onClick={() => navigate(`/jobs/update/${job.id}`)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                    >
                      Update
                    </button>
                    <button
                      onClick={() => alert(`Deleted job: ${job.title}`)}
                      className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => navigate(`/jobs/${job.id}`)}
                      className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    >
                      Explore
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Internships Table */}
      <div>
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-xl font-semibold text-gray-800">Latest Internships</h2>
          {internships.length > maxVisible && (
            <button
              onClick={() => navigate("/internships/all")}
              className="text-blue-600 hover:underline text-sm font-medium"
            >
              View More →
            </button>
          )}
        </div>
        <div className="overflow-x-auto bg-white rounded-lg shadow">
          <table className="w-full text-left">
            <thead className="bg-gray-200 text-gray-700">
              <tr>
                <th className="p-3">Title</th>
                <th className="p-3">Company</th>
                <th className="p-3">Location</th>
                <th className="p-3">Posted</th>
                <th className="p-3 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {internships.slice(0, maxVisible).map((intern) => (
                <tr key={intern.id} className="border-b hover:bg-gray-50">
                  <td className="p-3">{intern.title}</td>
                  <td className="p-3">{intern.company}</td>
                  <td className="p-3">{intern.location}</td>
                  <td className="p-3">{intern.postedAt}</td>
                  <td className="p-3 text-right flex justify-end gap-2">
                    <button
                      onClick={() => navigate(`/internships/update/${intern.id}`)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                    >
                      Update
                    </button>
                    <button
                      onClick={() => alert(`Deleted internship: ${intern.title}`)}
                      className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => navigate(`/internships/${intern.id}`)}
                      className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    >
                      Explore
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
